import {TrackingService} from "./tracking_service";
import {TrackingFeatureLabels} from "./types";

export class TopBrandPromo {
    private readonly trackingService: TrackingService;
    private readonly _featureOrder: number;
    private readonly brandImageId: string;
    private readonly targetPSRBrand: string;
    private readonly tslMetaLabels: TrackingFeatureLabels;
    private readonly tileTslMetaLabels: TrackingFeatureLabels;
    private readonly masFeatureTrackingLabels: TrackingFeatureLabels;
    private readonly masNextPiTrackingLabels: TrackingFeatureLabels;
    private readonly _item: HTMLLinkElement;

    constructor(private container: Element) {
        this._item = container.querySelector('.promo-brandpromo__top-brandpromo a')!;
        this._featureOrder = this.getFeatureOrder(this.container);
        this.brandImageId = this.getBrandImageId(this.container);
        this.targetPSRBrand = this.getTargetPSRBrand(this.container);
        this.tslMetaLabels = this.getTslMetaLabels(this.container);
        this.tileTslMetaLabels = this.getTileTslMetaLabels(this.container);
        this.masFeatureTrackingLabels = this.getMasFeatureTrackingLabels(container);
        this.masNextPiTrackingLabels = this.getMasNextPiTrackingLabels(container);
        this.trackingService = new TrackingService()

        this.trackLoaded();
        this._item.addEventListener("click", (e: MouseEvent) => this.trackClick(e), false);
        this.registerVisibleTrackObserver();
    }

    trackClick(e: MouseEvent): void {
        if (e.target instanceof Element) {
            this.trackingService.sendTopBrandPromoClickTrackingEvent(this._featureOrder, this.brandImageId, this.targetPSRBrand, this.tslMetaLabels, this.tileTslMetaLabels, this.masFeatureTrackingLabels, this.masNextPiTrackingLabels);
        }
    }

    trackLoaded(): void {
        this.trackingService.sendTopBrandPromoInitialLoadedTrackingEvent(this._featureOrder, this.brandImageId, this.targetPSRBrand, this.tslMetaLabels, this.tileTslMetaLabels, this.masFeatureTrackingLabels);
    }

    registerVisibleTrackObserver(): void {
        /*                                     */
        const observer = new IntersectionObserver((entries) => {
            const intersectingEntries = entries.filter((entry) => entry.isIntersecting);
            if (intersectingEntries.length > 0) {
                this.trackingService.sendVisibleTrackingEvent(`ft3_tbp`, `ft3_tbp_tile0`);
                observer.unobserve(this.container);
            }
        }, {});

        observer.observe(this.container);
    }

    private getMasFeatureTrackingLabels(container: Element): TrackingFeatureLabels {
        const dataFeatureTrackingLabels = container.closest('[data-feature-tracking-labels]')?.getAttribute("data-feature-tracking-labels");
        return dataFeatureTrackingLabels ? JSON.parse(dataFeatureTrackingLabels) : {};
    }

    private getMasNextPiTrackingLabels(container: Element): TrackingFeatureLabels {
        const dataMasNextPiTrackingLabels = container.closest('[data-next-pi-tracking-labels]')?.getAttribute("data-next-pi-tracking-labels");
        return dataMasNextPiTrackingLabels ? JSON.parse(dataMasNextPiTrackingLabels) : {};
    }

    private getFeatureOrder(container: Element): number {
        const dataFeatureOrder = container.closest('[data-feature-order]')?.getAttribute('data-feature-order');
        return dataFeatureOrder ? parseInt(dataFeatureOrder, 0) : -1;
    }

    private getBrandImageId(container: Element): string {
        return container.getAttribute('data-brand-image-id')!;
    }

    private getTargetPSRBrand(container: Element): string {
        return container.getAttribute('data-target-psr-brand')!;
    }

    private getTslMetaLabels(container: Element): TrackingFeatureLabels {
        return container.getAttribute('data-tsl-meta-labels') ? JSON.parse(container.getAttribute('data-tsl-meta-labels')!) : {};
    }

    private getTileTslMetaLabels(container: Element): TrackingFeatureLabels {
        return container.getAttribute('data-tile-tsl-meta-labels') ? JSON.parse(container.getAttribute('data-tile-tsl-meta-labels')!) : {};
    }

    /*            */
    get featureOrder(): number {
        return this._featureOrder;
    }

    /*            */
    get item(): HTMLLinkElement {
        return this._item;
    }

    /*            */
    get testContainer(): Element {
        return this.container;
    }

}